import { BaseModel } from './base.model'

export class InfractionReason extends BaseModel<InfractionReason> {
  static DEFAULT_ATTRIBUTES = {}

  name: string
  detectable: boolean
  _destroy: boolean
}

export class Infraction extends BaseModel<Infraction> {
  static DEFAULT_ATTRIBUTES = {
    reasons: []
  }

  id: number
  name: string
  state: string
  infractionType: string
  reasons: InfractionReason[]

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }

  get isReasonable(): boolean {
    return this.infractionType == "Reasonable"
  }

  get type(): string {
    return this.infractionType == "Default" ? "Обычное" : "С указанием причины"
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/infraction.model.ts